window.scThemeConfig = {
  cartDiscountSelector: {
    path: ".discount-code__form .injector", // anchor element for cart page
    type: 0, // 0 before element, 1 -after element
  },
  ajaxDicountSelector: {
    path: ".discount-code__form .injector", // anchor element for cart drawer (ajax cart)
    type: 0, // 0 before element, 1 -after element
  },
  cartTotalSelector: {
    path: ".totals-row .totals__subtotal .total-value-price",
    type: 0,
  },
  // ajaxTotalSelector: {
  //   path: ".sticky-but2 .totals__subtotal-value",
  //   type: 0,
  // },
};

/* sticky subcollection and filter */
let prevScrollPos = window.pageYOffset;
let prevScrollPos2 = window.pageYOffset;
try {
  window.onscroll = function () {
    if (document.getElementById("facet-filters")) {
      makeSticky("facet-filters", "sticky");
    }

    if (
      document.getElementById(
        "shopify-section-template--20721408213283__faf07fe4-5de6-43bb-a2a4-053fcbbc3aba"
      )
    ) {
      makeSticky2(
        "shopify-section-template--20721408213283__faf07fe4-5de6-43bb-a2a4-053fcbbc3aba",
        "sticky"
      );
    }
  };

  function makeSticky(elementId, stickyClass) {
    const stickyElement = document.getElementById(elementId);
    const stickyElementOffset = stickyElement.offsetTop;
    const thresholdUp = 50;

    const currentScrollPos = window.pageYOffset;

    if (currentScrollPos < prevScrollPos) {
      if (currentScrollPos > stickyElementOffset + thresholdUp) {
        stickyElement.classList.add(stickyClass);
      } else {
        stickyElement.classList.remove(stickyClass);
      }
    } else {
      if (currentScrollPos > stickyElementOffset) {
        stickyElement.classList.add(stickyClass);
      } else {
        stickyElement.classList.remove(stickyClass);
      }
    }
    prevScrollPos = currentScrollPos;
  }

  function makeSticky2(elementId, stickyClass) {
    const stickyElement = document.getElementById(elementId);
    const stickyElementOffset = stickyElement.offsetTop;
    const thresholdUp = 50;

    const currentScrollPos = window.pageYOffset;

    if (currentScrollPos < prevScrollPos2) {
      if (currentScrollPos > stickyElementOffset + thresholdUp) {
        stickyElement.classList.add(stickyClass);
      } else {
        stickyElement.classList.remove(stickyClass);
      }
    } else {
      if (currentScrollPos > stickyElementOffset) {
        stickyElement.classList.add(stickyClass);
      } else {
        stickyElement.classList.remove(stickyClass);
      }
    }
    prevScrollPos2 = currentScrollPos;
  }
} catch (e) {}

var submitSVGs = document.querySelectorAll(
  ".ed-search-bar .predictive-search__form svg"
);
submitSVGs.forEach(function (svg) {
  svg.addEventListener("click", function () {
    var form = this.closest("form");
    if (form) {
      form.submit();
    }
  });
});

/* quantity selector script */
$(function () {
  $(".block-swatch__item").click(function () {
    var max = $(this).attr("data-stock");
    max = Number(max);
    if (max < 15) {
      var selectElement = document.getElementById("product-qty-selector");
      selectElement.innerHTML = "";
      for (var i = 1; i <= max; i++) {
        var option = document.createElement("option");
        option.value = i;
        option.text = i;
        selectElement.appendChild(option);
      }
    } else {
      var selectElement = document.getElementById("product-qty-selector");
      selectElement.innerHTML = "";
      for (var i = 1; i <= 15; i++) {
        var option = document.createElement("option");
        option.value = i;
        option.text = i;
        selectElement.appendChild(option);
      }
    }
  });
});

$(document).on("click", ".af_kd_title", function () {
  $(".cdThemeSetupV3").toggleClass("show_input");
});

$(function () {
  $(".product-meta__reviews-badge").click(function () {
    $(".review_tab").click();
    $(".reviews_tab button").click();
  });
});

$(function () {
  $(".shipping_info_link").click(function () {
    $("#tab-button-mbversandkosten").click();
    $("#tab-button-versandkosten").click();
  });
});

$(document).ready(function () {
  if ($(window).width() < 1000) {
    var collectionMenu = $(".collection-feature-menu");
    $(
      "#shopify-section-template--20721408213283__faf07fe4-5de6-43bb-a2a4-053fcbbc3aba"
    ).append(collectionMenu);
  }
});

/* announcement bar */
function mobileOnlySlider(
  $slidername,
  $dots,
  $arrows,
  $breakpoint,
  $autoplay,
  $autoplayspeed,
  $arrowicon
) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    dots: $dots,
    arrows: $arrows,
    autoplay: $autoplay,
    autoplaySpeed: $autoplayspeed,
    prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button">${$arrowicon}</button>`,
    nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button">${$arrowicon}</button>`,
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick",
      },
    ],
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}

// $(".custom_filter .product-facet__filter-list").slick({
//    dots: true,
//    arrows: false
// })

mobileOnlySlider(
  ".announcement-bar__list",
  false,
  true,
  767,
  true,
  Number($(".announcement-bar__list").attr("data-speed")),
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <g id="Group"> <g id="Group_2"> <path id="Path" d="M14 16L10 12L14 8" stroke="white" stroke-linecap="round" stroke-linejoin="round"/> </g> </g> </svg>'
);

mobileOnlySlider(
  ".image-with-text-slider .image-with-text-grid-wrap",
  true,
  false,
  767,
  false,
  3000,
  '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M16.495 3L7.5 12.027L16.5 21" stroke="#323232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>'
);

$(".gift-product-slider .down-part-wrap").slick({
  mobileFirst: true,
  dots: true,
  arrows: false,
  autoplay: false,
});

/* footer */

$(".footer-middle-heading").click(function (e) {
  e.preventDefault();
  $(this).parent("div").toggleClass("open");
});

$(".footer__item-title").click(function (e) {
  e.preventDefault();
  $(this).parent(".footer__item").toggleClass("open");
});

/* collection spotlight */

$(".collection-spotlight .atc-btn").click(async function (e) {
  e.preventDefault();
  let vid = $(this).attr("data-vid");
  let formData = {
    items: [
      {
        id: vid,
        quantity: 1,
      },
    ],
  };

  const res = await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: response.json(),
            openMiniCart:
              window.themeVariables.settings.cartType === "drawer" &&
              this.closest(".drawer") === null,
          },
        })
      );
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});

/* upsell products */
$(".tick-mark-box").click(function (e) {
  e.preventDefault();
  $(this).toggleClass("active");
  let price = 0;
  let compare = 0;
  let savings = 0;
  $(".tick-mark-box.active").each(function (i, e) {
    price = price + Number($(e).attr("data-price"));
    compare = compare + Number($(e).attr("data-compare"));
  });
  price = price / 100;
  compare = compare / 100;
  savings = compare - price;

  $(".total-bundle-price .compare_price").text(
    `UVP <span class="compare_striked">. ${compare}</span>€`
  );
  $(".total-bundle-price .sale_price").text(`${price}€`);
  $(".total-bundle-price .saved_price").text(`${savings.toFixed(2)}€ gespart`);
});

$(".bundle-atc").click(async function (e) {
  e.preventDefault();
  const ep = document.querySelectorAll(".tick-mark-box.active");
  let formData = {
    items: [],
  };
  ep.forEach(async function (el) {
    let item = {
      id: el.getAttribute("data-vid"),
      quantity: 1,
    };
    formData.items.push(item);
  });

  const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
        async (response2) => {
          const cartContent = await response2.json();
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:updated", {
              bubbles: true,
              detail: {
                cart: cartContent,
              },
            })
          );

          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: cartContent,
                openMiniCart: true,
              },
            })
          );
        }
      );
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});

$(".product-facet__filter-item .collapsible-toggle").attr(
  "aria-expanded",
  "false"
);
$(".product-facet__filter-item .collapsible-toggle").click(function () {
  $(".product-facet__filter-item .collapsible-toggle")
    .not($(this))
    .attr("aria-expanded", "false");
});

$(".main-cart-upsell .upsell-add-to-cart").click(function (e) {
  e.preventDefault();
  window.location.href = $(this).attr("data-href");
});

/* marken page */
try {
  document.addEventListener("DOMContentLoaded", function () {
    var brandSearchInput = document.getElementById("brand-search-landing");
    var brandLinks = document.querySelectorAll(".brand-link");
    var markenSectionContent = document.querySelector(
      ".marken-section-content"
    );
    if (brandSearchInput !== null) {
      brandSearchInput.addEventListener("input", function () {
        var inputValue = brandSearchInput.value.trim().toLowerCase();
        brandLinks.forEach(function (item) {
          var t = item.textContent.toLowerCase();
          if (inputValue === "") {
            brandLinks.forEach(function (link) {
              link.classList.remove("show_insearch");
            });
            markenSectionContent.classList.add("show_all");
          } else {
            markenSectionContent.classList.remove("show_all");
            if (t.includes(inputValue)) {
              item.classList.add("show_insearch");
            } else {
              item.classList.remove("show_insearch");
            }
          }
        });
      });
    }
    document
      .querySelectorAll(".marken-section-nav-wrap a")
      .forEach((anchor) => {
        anchor.addEventListener("click", function (e) {
          e.preventDefault();
          const targetId = this.getAttribute("href").substring(1);
          const targetElement = document.getElementById(targetId);
          if (targetElement) {
            const offset = 100;
            const targetOffset = targetElement.offsetTop - offset;
            window.scrollTo({
              top: targetOffset,
              behavior: "smooth",
              duration: 50000,
            });
          }
        });
      });
  });
} catch (e) {
  console.log(e);
}

$(function () {
  $(".collection-feature-menu_main").height(
    $(".collection-featured-collection").height() +
      $(".shopify-section--main-collection").height() -
      50
  );
});

$(window).scroll(function () {
  var scrollTopValue = $(window).scrollTop();
  if (scrollTopValue > 700) {
    $(".product-facet__filter-item .collapsible-toggle").attr(
      "aria-expanded",
      "false"
    );
  }
});

const labelLists = document.querySelectorAll(".product-item__label-list");
labelLists.forEach((labelList) => {
  const labelElements = labelList.querySelectorAll(".label_position");
  const labelArray = Array.from(labelElements);
  labelArray.sort((a, b) => {
    const positionA = parseInt(a.getAttribute("label-position"));
    const positionB = parseInt(b.getAttribute("label-position"));
    return positionA - positionB;
  });
  labelList.innerHTML = "";
  labelArray.forEach((span) => labelList.appendChild(span));
});

// label hide collection page

document.addEventListener("DOMContentLoaded", function () {
  console.log("run");
  const shadowRoot = document.querySelector(
    "shopify-accelerated-checkout-cart"
  ).shadowRoot;
  const style = document.createElement("style");
  style.textContent = `
      .wallet-cart-grid .wallet-cart-button-container:first-child {
          margin-top: 8px;
          display: none;
      }
  `;
  shadowRoot.appendChild(style);
  var brandSearchInputs = document.querySelectorAll(".brand_search");
  for (let brandSearchInput of brandSearchInputs) {
    brandSearchInput.addEventListener("input", function () {
      var markenSectionContent = this.nextElementSibling;
      var brandLinks = markenSectionContent.querySelectorAll(
        ".checkbox-container"
      );
      var inputValue = this.value.trim().toLowerCase();
      brandLinks.forEach(function (item) {
        var t = item.getAttribute("data-value").toLowerCase();
        if (inputValue === "") {
          brandLinks.forEach(function (link) {
            link.classList.remove("show_insearch");
          });
          markenSectionContent.classList.add("show_all");
        } else {
          markenSectionContent.classList.remove("show_all");
          if (t.includes(inputValue)) {
            item.classList.add("show_insearch");
          } else {
            item.classList.remove("show_insearch");
          }
        }
      });
    });
  }
});

$(document).ready(function () {
  if (window.location.href.includes("filter.p.vendor")) {
    $(
      '.template_collection.template_suffix_  button[aria-controls="facet-filter-filter.p.m.custom.serie"]'
    ).css({
      display: "flex",
    });
  } else {
    $(
      '.template_collection.template_suffix_  button[aria-controls="facet-filter-filter.p.m.custom.serie"]'
    ).css({
      display: "none",
    });
  }

  $(".close_item").click(function () {
    $(this)
      .parents(".collapsible")
      .siblings(".collapsible-toggle")
      .attr("aria-expanded", "false");
  });
});

$(function () {
  $(".product-tabs__content .collapsible-toggle").click(function () {
    $(".product-tabs__content .collapsible-toggle")
      .not($(this))
      .attr("aria-expanded", "false");
  });
});
document.addEventListener("DOMContentLoaded", function () {
  var elements = document.querySelectorAll(
    ".template_collection .product-item"
  );
  var percentage = Math.floor(elements.length * 0.2);
  for (var i = 0; i < percentage; i++) {
    var randomIndex = Math.floor(Math.random() * elements.length);
    elements[randomIndex].classList.add("show_badge");
  }
});

const tabItemWrappers = document.querySelectorAll(
  ".product-tabs__tab-item-wrapper"
);
const customOffset = 200;
tabItemWrappers.forEach((tabItemWrapper) => {
  tabItemWrapper.addEventListener("click", function () {
    if (
      event.target.tagName === "BUTTON" &&
      event.target.classList.contains("collapsible-toggle")
    ) {
      const elementToScroll = this;
      const elementRect = elementToScroll.getBoundingClientRect();
      const offsetTop = elementRect.top - customOffset;
      elementToScroll.scrollIntoView({ behavior: "smooth", block: "start" });
      window.scrollBy({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  });
});

// DISCOUNT CODE BAR: Analyse cookies and manipulate HTML
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
}

function handleDiscountCode(element) {
  const discountCode = getCookie("discount_code")?.toLowerCase();
  const promoDiscountCode = element
    .getAttribute("data-promo-discount-code")
    ?.toLowerCase();
  const promoRedeemedText = element.getAttribute("data-promo-redeemed-text");
  const promoHandling = element.getAttribute("data-promo-handling");

  if (promoHandling === "redeem" && discountCode === promoDiscountCode) {
    const innerElement = element.querySelector(".discount-code-bar__inner");
    if (innerElement) {
      innerElement.innerHTML = `<div class="discount-code-bar__redeemed">${promoRedeemedText}</div>`;
    }
  } else if (promoHandling === "copy") {
    const promoCodeLink = element.querySelector(
      ".discount-code-bar__promo-code a"
    );
    if (promoCodeLink) {
      promoCodeLink.addEventListener("click", function (event) {
        event.preventDefault();
        if (promoCodeLink.dataset.clicking === "true") {
          return; // Bereits ein Klick aktiv
        }
        promoCodeLink.dataset.clicking = "true";
        const promoDiscountCode = element.getAttribute(
          "data-promo-discount-code"
        );
        const promoCopyText = element.getAttribute("data-promo-copy-text");
        copyDiscountCode(promoDiscountCode);
        const originalInnerHTML = promoCodeLink.innerHTML;
        promoCodeLink.innerHTML = `<span class="copy-success-message">${promoCopyText}</span>`;
        const successMessage = promoCodeLink.querySelector(
          ".copy-success-message"
        );
        setTimeout(function () {
          promoCodeLink.innerHTML = originalInnerHTML;
          successMessage.remove();
          promoCodeLink.dataset.clicking = "false";
        }, 2000);
      });
    }
  }
}

function copyDiscountCode(code) {
  const textarea = document.createElement("textarea");
  textarea.value = code;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
}

document.addEventListener("DOMContentLoaded", function () {
  const discountCodeBarElements = document.querySelectorAll(
    ".container.discount-code-bar__inner"
  );
  const discountCodeBar = document.querySelectorAll(".discount-code-bar");

  discountCodeBar.forEach(function (element) {
    const discountCodeHandling = element.getAttribute("data-promo-handling");
    if (
      element.hasAttribute("data-promo-discount-code") &&
      element.hasAttribute("data-promo-redeemed-text")
    ) {
      handleDiscountCode(element);
    }
  });
});

// DISCOUNT CODES IN CART: Calculation
document.addEventListener("DOMContentLoaded", function () {
  let isUpdating = false;

  function updateCartSavings() {
    var cartSavingsWrapper = document.querySelector(".cart-savings_wrapper");
    var cartSavingsValue = document.querySelector(".cart-savings_text span");
    var savingsData = cartSavingsWrapper
      ? parseFloat(cartSavingsWrapper.getAttribute("data-savings"))
      : 0;

    var discountAmount = 0;
    var scDiscountData = JSON.parse(sessionStorage.getItem("scDiscountData"));
    if (
      scDiscountData &&
      scDiscountData.discount &&
      scDiscountData.discount.amount
    ) {
      discountAmount = parseFloat(scDiscountData.discount.amount) * 100;
      if (isNaN(discountAmount)) {
        discountAmount = 0;
      }
    }
    var totalSavingsValue = (savingsData + discountAmount) / 100;

    var totalSavings = totalSavingsValue.toLocaleString("de-DE", {
      style: "currency",
      currency: "EUR",
      currencyDisplay: "narrowSymbol",
    });
    totalSavings = totalSavings.replace(/\s/g, "");
    if (cartSavingsValue) {
      // cartSavingsValue.innerHTML = totalSavings;
      // cartSavingsWrapper.setAttribute("data-savings", savingsData);
    }

    // console.log("Savings Data:", savingsData);
    // console.log("Discount Amount:", discountAmount);
    // console.log("Total Savings Value:", totalSavingsValue);

    var totalsRowDiscountDiv = document.querySelector(
      ".totals-row_totals__discount"
    );
    var subtotalDiscountValue = document.querySelector(".subtotal-discount");
    var discountAmountValue = discountAmount / 100;
    var discountAmountCurr = discountAmountValue.toLocaleString("de-DE", {
      style: "currency",
      currency: "EUR",
      currencyDisplay: "narrowSymbol",
    });
    discountAmountCurr = discountAmountCurr.replace(/\s/g, "");

    if (totalsRowDiscountDiv && subtotalDiscountValue) {
      setTimeout(function () {
        if (discountAmount !== 0) {
          totalsRowDiscountDiv.style.display = "flex";
          subtotalDiscountValue.innerHTML = "-" + discountAmountCurr;
        } else {
          totalsRowDiscountDiv.style.display = "none";
        }
      }, 0);
    }
  }

  function updatePrices() {
    if (!isUpdating) {
      isUpdating = true;
      updateCartSavings();
      console.log("Aktualisiere Preise");

      setTimeout(() => {
        isUpdating = false;
      }, 1000);
    }
  }

  window.addEventListener("sc:discount.calculated", function () {
    updatePrices();
  });
  document.addEventListener("cart:updated", function () {
    console.log("Cart Update");
    updatePrices();
  });
});

// Toggle Discount Code Field
function toggleDiscountContainer() {
  var scDiscountContainer = document.querySelector(".discount-code__form");
  if (scDiscountContainer) {
    var isOpen = scDiscountContainer.classList.contains("is-open");
    if (!isOpen) {
      scDiscountContainer.classList.add("is-open");
    } else {
      scDiscountContainer.classList.remove("is-open");
    }
  }
}

// Toggle Cart Update in ATC via Wishlist
function onSwymLoadCallback(swat) {
  if (swat) {
    swat.evtLayer.addEventListener("sw:addedtocart", async function (e) {
      var miniCart = document.getElementById("mini-cart");

      try {
        const cartResponse = await fetch(
          window.Shopify.routes.root + "cart.js",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const cartData = await cartResponse.json();

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartData,
              openMiniCart:
                window.themeVariables.settings.cartType === "drawer" &&
                miniCart === null,
            },
          })
        );
      } catch (error) {
        console.error("Error:", error);
      }

      if (miniCart) {
        miniCart.setAttribute("open", "true");
      }
    });
  }
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);

document.addEventListener("DOMContentLoaded", reservationTimer);


// ---------- Start - Sticky Suche ausblenden  --------------

document.addEventListener("DOMContentLoaded", function(){
  const searchBtn = document.querySelector('.header__icon-search-btn');
  if(searchBtn){
    searchBtn.addEventListener('click',()=>{
      document.body.classList.remove('hide_sticky_search');
    });
  } 
});

// ---------- Start - Sticky Suche ausblenden  --------------